import classNames from 'classnames'
import { FunctionComponent } from 'react'
import { UXComponentType } from '../../UXComponentRenderer/uxComponent.types'
import { Image } from '../Image/Image'
import { Image as ImageProps } from '../Image/Image.types'
import './Icon.scss'
import { Icon as IconProps, IconType } from './Icon.types'
import { mapIconTypeToAsset } from './icon.utils'

const IconAsset = ({
  attributes,
  className
}: {
  attributes: IconProps['attributes']
  className?: string
}) => {
  const IconAsset =
    typeof attributes.asset === 'string'
      ? mapIconTypeToAsset(attributes.asset as IconType)
      : null

  if (!IconAsset) {
    return null
  }

  return (
    <IconAsset
      data-testid="core-ux-icon"
      className={classNames(
        'core-ux-icon',
        attributes.size && `core-ux-icon--${attributes.size}`,
        className
      )}
      style={{
        ...(attributes.color && {
          color: attributes.color,
          stroke: attributes.color
        })
      }}
    />
  )
}

const isIconType = (asset: string): asset is IconType =>
  !!asset && !asset.startsWith('http')

const isImage = (asset: string | ImageProps): asset is ImageProps =>
  typeof asset === 'object' && asset.type === UXComponentType.Image

export const Icon: FunctionComponent<IconProps> = ({
  version,
  attributes,
  className
}) => {
  if (isImage(attributes.asset)) {
    return <Image {...attributes.asset} className={className} />
  }

  if (!isIconType(attributes.asset)) {
    return (
      <Image
        type={UXComponentType.Image}
        version={version}
        attributes={{ url: attributes.asset }}
        className={className}
      />
    )
  }

  return <IconAsset attributes={attributes} className={className} />
}
